import angular from 'angular';
import uiRouter from 'angular-ui-router';
import adpSelectComponent from './adpSelect.component';

let adpSelectModule = angular.module('adpSelect', [
  uiRouter
])

.component('adpSelect', adpSelectComponent)

.name;

export default adpSelectModule;



// WEBPACK FOOTER //
// ./src/app/components/adpSelect/adpSelect.js